import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useContext, forwardRef } from 'react';
import { Fade } from '../Transitions/Fade';
import SelectableContext, { makeEventKey } from '../SelectableContext';
import TabContext from './TabContext';
function useTabContext(props) {
    const context = useContext(TabContext);
    if (!context) return props;
    const { activeKey, getControlledId, getControllerId, ...rest } = context;
    const shouldTransition = props.transition !== false && rest.transition !== false;
    const key = makeEventKey(props.eventKey);
    return {
        ...props,
        active: (props.active === null || props.active === undefined) && key !== null && key !== undefined ? makeEventKey(activeKey) === key : props.active,
        id: getControlledId(props.eventKey),
        'aria-labelledby': getControllerId(props.eventKey),
        transition: shouldTransition && (props.transition || rest.transition || Fade),
        mountOnEnter: props.mountOnEnter !== null && props.mountOnEnter !== undefined ? props.mountOnEnter : rest.mountOnEnter,
        unmountOnExit: props.unmountOnExit !== null && props.unmountOnExit !== undefined ? props.unmountOnExit : rest.unmountOnExit
    };
}
export const TabPane = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { className, active, onEnter, onEntering, onEntered, onExit, onExiting, onExited, mountOnEnter, unmountOnExit, transition: Transition, componentClass: Component = 'div', // eslint-disable-next-line @typescript-eslint/no-unused-vars
    eventKey: _, ...rest } = useTabContext(props);
    if (!active && !Transition && unmountOnExit) return null;
    let pane = /*#__PURE__*/ _jsx(Component, {
        ...rest,
        ref: ref,
        role: "tabpanel",
        "aria-hidden": !active,
        className: classNames(className, 'tab-pane', {
            active
        })
    });
    if (Transition) pane = /*#__PURE__*/ _jsx(Transition, {
        in: active,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        children: pane
    });
    // We provide an empty the TabContext so `<Nav>`s in `<TabPane>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ _jsx(TabContext.Provider, {
        value: null,
        children: /*#__PURE__*/ _jsx(SelectableContext.Provider, {
            value: null,
            children: pane
        })
    });
});
TabPane.displayName = 'TabPane';
